import UnitMeasurementsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements/unit-measurements.entity';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DocumentNavigationComponent } from 'app/common/components/document-navigation/document-navigation.component';

interface OrderConflict {
  serial: string;
  soldUnitOfMeasure: UnitMeasurementsAttributes;
  unitPrice?: number;
}

interface MaterialConflict {
  materialCode: string;
  materialName: string;
  orders: OrderConflict[];
}

export interface ConflictDialogData {
  conflicts: MaterialConflict[];
  allowDiffComercialConds: boolean;
}

@Component({
  selector: 'app-unify-modal',
  templateUrl: './order-unify-modal.component.html',
  styleUrls: ['./order-unify-modal.component.scss'],
  imports: [
    MatIconModule,
    MatExpansionModule,
    MatButtonModule,
    CommonModule,
    DocumentNavigationComponent,
    MatDialogModule,
  ],
  standalone: true  
})
export class ConflictModalComponent {
  expandedMaterial: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<ConflictModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConflictDialogData
  ) {
    console.log('Data recibida:', this.data);
    // Si solo hay un material, expandirlo por defecto
    if (this.data.conflicts.length === 1) {
      this.expandedMaterial = this.data.conflicts[0].materialCode;
    }
  }

  // SOLUCIÓN: Método separado para manejar el toggle
  onPanelToggle(materialCode: string, isOpen: boolean): void {
    this.expandedMaterial = isOpen ? materialCode : null;
  }

  isExpanded(materialCode: string): boolean {
    return this.expandedMaterial === materialCode;
  }

  close(): void {
    this.dialogRef.close();
  }

  // TrackBy para optimizar ngFor
  trackByMaterialCode(index: number, conflict: MaterialConflict): string {
    return conflict.materialCode;
  }

  trackByOrderSerial(index: number, order: OrderConflict): string {
    return order.serial;
  }
}